export class PccAuditInfo {
	/**
	 * The recorded date the record was created. The date and time are expressed in UTC in the following format YYYY-MM-DDTHH:MM:SS.sssZ.
	 */
	createdDate: string;

	/**
	 * The recorded date the record was created formatted in the following format December 15, 2025
	 */
	createdDateFormatted: string;

	/**
	 * The recorded client/user name who created the record.
	 */
	createdBy: string;

	/**
	 * The recorded date the record was last revised. The date and time are expressed in UTC in the following format YYYY-MM-DDTHH:MM:SS.sssZ.
	 */
	revisionDate: string;

	/**
	 * The recorded date the record was last revised formatted in the following format December 15, 2025
	 */
	revisionDateFormatted: string;

	/**
	 * The recorded client/user name who last revised the record.
	 */
	revisionBy: string;

	/**
	 * The recorded date the record was initiated. The date and time are expressed in UTC in the following format YYYY-MM-DDTHH:MM:SS.sssZ.
	 */
	initiatedDate: string;

	/**
	 * The recorded date the record was resolved. The date and time are expressed in UTC in the following format YYYY-MM-DDTHH:MM:SS.sssZ.
	 */
	resolvedDate: string;
}
